export default __webpack_public_path__ + "static/media/H0004.92035f9d.png";